import React from 'react';
import PropTypes from 'prop-types';
import { AnimatePresence, motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

/**
 * Efeito de transição ao trocar de tela - usado uma vez em MainLayout
 * (não em cada página). Cada rota entra com um leve fade + slide-up,
 * trocado suavemente conforme `location.pathname` muda.
 */
const PageTransition = ({ children }) => {
    const location = useLocation();

    return (
        <AnimatePresence mode="wait">
            <motion.div
                key={location.pathname}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -6 }}
                transition={{ duration: 0.22, ease: [0.4, 0, 0.2, 1] }}
            >
                {children}
            </motion.div>
        </AnimatePresence>
    );
};

PageTransition.propTypes = {
    children: PropTypes.node
};

export default PageTransition;
